import React from "react";
import '../screens/Speech.css';

export default function Filter({change, settings, changeFilterType}){

	const {frequency, detune, Q, gain, type} = settings;

	return(
		<div className='control'>
			<h2>Filtr</h2>
			<div className='param'>
				<h3>Częstotliwość</h3>
				<input value={frequency} type='range' onChange={change} id='frequency' max='10000' className='input'/>
			</div>
			<div className='param'>
				<h3>Rozstrajanie</h3>
				<input value={detune} type='range' onChange={change} id='detune' className='input'/>
			</div>
			<div className='param'>
				<h3>Q</h3>
				<input value={Q} type='range' onChange={change} id='Q' max='10' step='0.1' className='input'/>
			</div>
			<div className='param'>
				<h3>Przyrost</h3>
				<input value={gain} type='range' onChange={change} id='gain' max='10' step='0.1' className='input'/>
			</div>
			<div className='param'>
				<h3>Filtr</h3>
				<button id='lowpass' onClick={changeFilterType} className={type==='lowpass'?'btnF activeF':'btnF noactiveF'}>
					dolnoprzepustowy</button>
				<button id='highpass' onClick={changeFilterType} className={type==='highpass'?'btnF activeF':'btnF noactiveF'}>
					wysokoprzepustowy</button>
				<button id='notch' onClick={changeFilterType} className={type==='notch'?'btnF activeF':'btnF noactiveF'}>
					środkowozaporowy</button>
				<button id='lowshelf' onClick={changeFilterType} className={type==='lowshelf'?'btnF activeF':'btnF noactiveF'}>
					środkowoprzepustowy</button>
				{/*<button id='highshelf' onClick={changeFilterType} className={type==='highshelf'?'btnF activeF':'btnF noactiveF'}>
					Inne</button>*/}
			</div>
		</div>
	);
}